import { render, staticRenderFns } from "./serveMsgDetail.vue?vue&type=template&id=5bef3735&scoped=true&"
import script from "./serveMsgDetail.vue?vue&type=script&lang=js&"
export * from "./serveMsgDetail.vue?vue&type=script&lang=js&"
import style0 from "./serveMsgDetail.vue?vue&type=style&index=0&id=5bef3735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bef3735",
  null
  
)

component.options.__file = "serveMsgDetail.vue"
export default component.exports